import http from "./http";

//获取反馈列表
export const updateAdmin = async (data) => {
    return await http.post(`admin/ctrl/update`, data);
};